import { assign, merge, pick } from 'lodash'

const DATA_KEYS = [
  'class',
  'staticClass',
  'style',
  'attrs',
  'props',
  'domProps',
  'on',
  'nativeOn',
  'directives',
  'scopesSlots',
  'slot',
  'ref',
  'key'
]

function extractData (vnode, isComponent) {
  const data = pick(vnode.data, DATA_KEYS)

  if (isComponent) {
    assign(data, { props: vnode.componentOptions.propsData, on: vnode.componentOptions.listeners })
  }

  if (data.key) {
    data.key = `${data.key}-cloned`
  }

  return data
}

function cloneVNode (vnode, data = {}) {
  // use the context that the original vnode was created in.
  const h = vnode.context && vnode.context.$createElement
  const isComponent = !!vnode.componentOptions
  const isText = !vnode.tag // this will also match comments but those will be dropped, essentially
  const children = isComponent ? vnode.componentOptions.children : vnode.children

  if (isText) {
    return vnode.text
  }

   const tag = isComponent ? vnode.componentOptions.Ctor : vnode.tag

  const childNodes = children ? children.map(c => cloneVNode(c)) : undefined
  return h(tag, merge(extractData(vnode, isComponent), data), childNodes)
}

export default {
  install: function (Vue) {
    Object.defineProperties(Vue.prototype, {
      '$cloneNode': {
        get () {
          return cloneVNode
        }
      }
    })
  }
}
